import React from "react";
import { useTranslation } from "react-i18next";
import UnauthorizedErrorPage from "./UnauthorizedErrorPage";
const StreamPermissionErrorPage = ({ error, missingStreamIds = [] }) => {
  var _a, _b;
  const { t } = useTranslation("streams");
  const description = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("stream_permission_error_page.description_p1")), /* @__PURE__ */ React.createElement("p", null, t("stream_permission_error_page.description_p2")));
  const streamIds = missingStreamIds.length > 0 ? missingStreamIds : (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.streams;
  const errorDetails = (streamIds == null ? void 0 : streamIds.length) > 0 ? t("stream_permission_error_page.error_details", { ids: streamIds.join(", ") }) : void 0;
  return /* @__PURE__ */ React.createElement(
    UnauthorizedErrorPage,
    {
      error,
      description,
      title: t("stream_permission_error_page.title"),
      errorDetails
    }
  );
};
export default StreamPermissionErrorPage;
